import React, { FC } from 'react';
import { Text } from 'react-native';

import { scale as initialScale } from '@components/frame';
import { font as initialFont } from '@styles/fonts';
import { isPhone } from '@helpers';
import type { WithColor } from '@styles/colors';
import type { ScaleFunction } from '@components/operatorPanel/interfaces';
import type { ImagesContainerProps } from '@v2/pages/common/components/ImagesContainer/ImagesContainer';

import { useManageAddImageLabel } from '@components/machines/components/detailsComponents/activeMachine/components/Images/components/AddImageLabel/hooks/useManageAddImageLabel';

export interface AddImageLabelProps extends WithColor, Pick<ImagesContainerProps, 'machineId' | 'documentRetrieveKey'> {
  scale?: ScaleFunction;
  font?: typeof initialFont;
}

export const AddImageLabel: FC<AddImageLabelProps> = (props) => {
  const { C, scale = initialScale, font = initialFont } = props;
  const { text } = useManageAddImageLabel(props);

  return (
    <Text style={[font['Button 1'], { color: C('Link/Light/Primary'), marginTop: scale(isPhone ? 0 : 8) }]}>
      {text}
    </Text>
  );
};
